// extracted by mini-css-extract-plugin
module.exports = {"root":"LpuUjmHmWiVBWP8pjE5G","hasBullets":"RqLRlvLSrmyZ0jbyxXpE"};